<template>
  <div class="progress chart-progress" v-loading="!init">
    <el-radio-group size="small" v-model="type" style="margin-bottom: 20px;"
                    v-if="!$store.state.project.plan || !$store.state.project.plan.id">
      <el-radio-button label="Исполнители"></el-radio-button>
      <el-radio-button label="Объекты"></el-radio-button>
      <el-radio-button label="Раздел"></el-radio-button>
    </el-radio-group>
    <div class="chart" v-if="init">
      <div style="height: 200px">
        <ProgressBar
          :isShowLabel="isCurrentPlan"
          :label="analytics.laborIntensityJobs.percentagePlan"
          :value1="analytics.laborIntensityJobs.percentagePlan" :value2="100"/>
      </div>
      <div class="labels-custom" style="margin-left: 20px; display: flex; justify-content: center">
        <span class="strong">Норма: {{
            numberWithSpaces(toFixedWithoutZero(analytics.laborIntensityJobs.plan))
          }}</span>
        <span class="strong">Факт: {{
            numberWithSpaces(toFixedWithoutZero(analytics.laborIntensityJobs.fact))
          }}</span>
      </div>


      <div style="margin-bottom: 120px">
        <div style="margin-top: 40px" class="chart-container-companies" v-for="comp in companies" :key="comp.label">
          <strong class="label-chart" style="margin-bottom: 10px">{{ comp.label }}</strong>
          <div class="chart-company">
            <div class="horizontal-container">
              <horizontal-chart
                :width="250"
                :height="75"
                v-if="init"
                :chart-data="comp.data"
                :options="chartOptionsCompany">
              </horizontal-chart>
              <!--              <div class="horizontal-label">-->
              <!--                <span :style="{marginLeft: `${comp.percentageProjectPlan > 99 ? 100 : comp.percentageProjectPlan + 2}%`}">{{ comp.percentageProjectPlan }}%</span>-->
              <!--                <span :style="{marginLeft: `${comp.percentagePlan > 99 ? 100 : comp.percentagePlan + 2}%`}">{{ comp.percentagePlan }}%</span>-->
              <!--              </div>-->
              <strong class="percent"
                      :style="{color: pStatus(comp.percent), padding: 0}">
                {{ Number(comp.percent).toFixed(0) || 0 }}%
              </strong>
            </div>
          </div>
          <div class="labels-custom">
            <div style="display: flex">

              <span class="strong">Норма: {{ numberWithSpaces(toFixedWithoutZero(comp.plan)) }}</span>
              <span class="strong">Факт: {{ numberWithSpaces(toFixedWithoutZero(comp.fact)) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import BarChart from "./BarChart";
import HorizontalChart from "./HorizontalChart";
import {numberWithSpaces, toFixedWithoutZero} from "../../../utils/numberUtils";
import ProgressBar from "./components/ProgressBar";
import {isApiRuleIgnore} from "../../../plugins/firebase";

export default {
  name: "Progress",
  components: {ProgressBar, HorizontalChart, BarChart},
  data() {
    return {
      type: 'Исполнители',
      init: false,
      isCurrentPlan: false,
      chartData: {
        labels: ['План', 'Факт'],
        datasets: [{
          data: [0, 0],
          barThickness: 60,
          backgroundColor: [
            'rgba(54, 162, 235, 0.2)',

            'rgba(255, 99, 132, 0.2)',
          ],
          borderColor: [
            'rgb(54, 162, 235)',

            'rgb(255, 99, 132)',
          ],
          borderWidth: 1
        }],
      },
      chartDataCompany: {
        labels: ['План', 'Факт'],
        datasets: [{
          data: [10, 22],
          barThickness: 20,
          backgroundColor: [
            'rgba(54, 162, 235, 0.2)',
            'rgba(255, 99, 132, 0.2)',
          ],
          borderColor: [
            'rgb(54, 162, 235)',
            'rgb(255, 99, 132)',
          ],
          borderWidth: 1
        }],
      },
      chartOptions: {
        minBarLength: 100,
        responsive: true,
        maintainAspectRatio: false,
        barValueSpacing: 20,
        legend: {
          display: false
        },
        scales: {
          yAxes: [{
            ticks: {min: 0},
          }],
          xAxes: [{
            display: false
          }]
        }
      },
      chartOptionsCompany: {
        minBarLength: 100,
        responsive: true,
        maintainAspectRatio: false,
        barValueSpacing: 1,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            ticks: {min: 0},
          }],
          yAxes: [{
            display: false
          }]
        }
      },
      analytics: {
        laborIntensityJobs: {
          plan: 0,
          fact: 0,
          percentagePlan: 0,
          companies: {
            company: {
              plan: 0,
              fact: 0,
              percentagePlan: 0
            }
          }
        }
      }
    }
  },
  async mounted() {
    await this.getAnalytics();
  },
  computed: {
    companies() {
      const data = this.analytics.laborIntensityJobs.companies || this.analytics.laborIntensityJobs.objects || this.analytics.laborIntensityJobs.items

      if (!this.analytics.laborIntensityJobs || !data) {
        return []
      }

      return Object.entries(data).map(([key, obj]) => {

        const fact = obj.plan ? obj.percentagePlan : 100

        let parse = [obj.plan ? 100 : 0, fact || 0]

        if (!obj.plan && !obj.fact) {
          parse = [0, 0]
        }

        return ({
          label: key,
          percent: obj.percentagePlan,
          percentagePlan: obj.percentagePlan,
          percentageProjectPlan: obj.percentageProjectPlan,
          fact: obj.fact,
          plan: obj.plan,
          data: {
            labels: ['Норма', 'Факт'],
            datasets: [{
              data: parse,
              barThickness: 20,
              backgroundColor: [
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 99, 132, 0.2)',
              ],
              borderColor: [
                'rgb(54, 162, 235)',
                'rgb(255, 99, 132)',
              ],
              borderWidth: 1
            }],
          }
        })
      });
    }
  },
  watch: {
    isCurrentPlan() {
      this.getAnalytics(this.type === 'Объекты');
    },
    type() {
      this.getAnalytics(this.type === 'Объекты');
    }
  },
  methods: {
    numberWithSpaces,
    toFixedWithoutZero,
    async getAnalytics() {
      this.init = false
      let versionStorage = localStorage.getItem('version')
      if(versionStorage) {
        versionStorage = JSON.parse(versionStorage)
      }
      const version = (this.$store.state.project.version && this.$store.state.project.version.id) || (versionStorage && versionStorage.id)

      let url = `onAggregateProductivityLaborIntensityJobs${version ? 'ByVersionPlan' : ''}/${this.$store.state.project.id}&queryParams=uid=${authFirestore.currentUser.uid}`

      if (version) {
        url += `, planId=${version}`
      } else if (this.$store.state.project.plan && this.$store.state.project.plan.id) {
        url += `, planId=${this.$store.state.project.plan.id}`
      }

      if (this.type === 'Объекты') {
        url += `, isObjects=true`
      }

      if (this.type === 'Раздел') {
        url += `, isDirs=true`
      }

      if (isApiRuleIgnore) {
        url = url.replace('&queryParams=', '?').replace(/, /g, "&")
      }

      const proxy = firebase.functions().httpsCallable(
        url
      );
      const {data} = await proxy(
        {
          uid: authFirestore.currentUser.uid,
          planId: (this.$store.state.project.plan && this.$store.state.project.plan.id) || version || null,
        },
      );
      this.analytics.laborIntensityJobs = data.laborIntensityJobs;

      const fact = this.analytics.laborIntensityJobs.plan ? this.analytics.laborIntensityJobs.percentagePlan : 100
      let parse = [this.analytics.laborIntensityJobs.plan ? 100 : 0, fact || 0];


      if (!this.analytics.laborIntensityJobs.plan && !this.analytics.laborIntensityJobs.fact) {
        parse = [0, 0]
      }

      this.chartData.datasets[0].data = [parse[0], parse[1]]
      this.chartData.labels = [`Норма ${parse[0]}`, `Факт ${parse[1]}`];
      this.init = true
    },
    pStatus(n) {
      if (n >= 99) {
        return '#7CB342'
      }

      if (n > 70) {
        return '#F57C00'
      }

      return '#D32F2F'
    }
  }
}
</script>

<style scoped lang="scss">
.horizontal-container {
  display: flex;
}
.progress {
  max-width: 600px;
  margin: 0 auto;
  // IOS ONLY REMOVE
  margin-top: -25px;


  .chart {
    margin: 0 auto;

    max-width: 400px;
    overflow: hidden;

    .percent {
      font-size: 18px;
      padding-left: 6px;
    }

    .chart-container {
      display: flex;
      align-items: center;
    }
  }
}

.chart-container-companies {
  width: 400px;
  display: flex;
  align-items: flex-start;
  padding-left: 20px;
  flex-direction: column;

  .chart-company {
    display: flex;
  }

}

.labels-custom {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  flex: 1;
  width: 100%;
  text-align: center;

  span {
    color: #000;
    font-size: 13px;
    margin-top: 12px;
    margin-right: 20px;
  }
}

.strong {
  font-weight: bold;
}

.label-chart {
  text-align: left;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-width: calc(100% - 60px);

}
</style>

<style lang="scss">
.chart-progress {
  .el-radio-button__inner {
    width: 100px !important;
    padding: 12px 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Analytics/ProgressPlanWork.vue